export default __webpack_public_path__ + "static/media/026-red envelope.72965a1f.svg";